export default __webpack_public_path__ + "static/media/Hero-Picture 3 - without text.4af52b92.jpg";